import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API,
    timeout: 60000,
    headers: { "Content-Type": "application/json" },
});

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        if (response.status !== 200) {
            return Promise.reject(response.data);
        }
        if (response.data && response.data.code === "401") {
            window.location.href = !process.env.PUBLIC_URL ? "" : process.env.PUBLIC_URL + "/login"
        }
        return Promise.resolve(response.data);
    },
    (error) => {
        return Promise.reject(error);
    }
);
export const get = (url, params) => instance.get(url, { params });

export const post = (url, data) => instance.post(url, data);

export const blob = (url, data) => instance.post(url, data, {
    responseType: 'blob',
});

export const formPost = (url, params) => {
    return instance.post(url, new URLSearchParams(params).toString(), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};